import * as angular from 'angular';

"use strict";

angular.module('SchedulersDataModule', []);

export default 'SchedulersDataModule';